<template>
    <div class="windows">
      <div class="container" style="margin-top: 20px;">
        <div class="row">
            <div class="col-12">
                <div style="margin-top:40px; position: fixed; top: 30%; right: 20px; transform: translateY(-50%); z-index: 10;">
                    <el-button style="margin-bottom: 10px;" v-show="this.$route.query.id" type="danger" icon="el-icon-delete" circle @click="ClickMeToDel"></el-button>
                    <div style="margin-bottom: 10px;"><el-button type="primary" icon="el-icon-edit" circle @click="close"></el-button></div>
                    <div style="margin-bottom: 10px;"><el-button type="success" icon="el-icon-check" circle @click="open"></el-button></div>
                    <div style="margin-bottom: 10px;"><el-button type="warning" round @click="ClickMeToSubmit">提交咯</el-button></div>
                </div>
            </div>
        </div>
        <div v-show="this.$route.query.id" class="row">
          <div class="col-12 text-center" style="font-size: 20px; color: red; font-weight: 600;">
            现在是修改页面
          </div>
        </div>
        <el-form label-position="left" label-width="80px">
            <el-form-item label="课程名称">
                <el-input v-model="course_name"></el-input>
            </el-form-item>
            <el-form-item label="课程价格">
                <el-input v-model="price"></el-input>
            </el-form-item>
        </el-form>
        <h4>上传课程图片</h4>

        <!-- <div>
          <input type="file" @change="handleFileUpload" accept="image/*" />
          <img v-if="imageUrl" :src="imageUrl" alt="Uploaded Image" style="max-width: 300px; margin-top: 20px;" />
          <p v-if="imageType">图片类型: {{ imageType }}</p>
          <button @click="uploadFile">上传到后端</button>
        </div> -->

        <el-input
            style="margin-top:10px;"
            placeholder="请输入图片名称"
            v-model="imageName">
        </el-input>

        <span v-if="imageName" style="margin-top: 10px;"> 图片链接 {{ image }}</span>
        <div style="margin-top: 10px;">
          <input type="file" @change="handleFileUpload" accept="image/*" />
          <img v-if="imageUrl" :src="imageUrl" alt="Uploaded Image" style="max-width: 300px; margin-top: 20px;" />
          <p v-if="imageType">图片类型: {{ imageType }}</p>
          <button @click="uploadFile">上传到后端</button>
        </div>

        <!-- 这一坨是说明你会学到什么 和 试听课 -->
        <div class="row">
          <div class="col-8" >
            <img src="@/assets/kcimg/studyed-title.png" alt="" width="120px">
            <div style="background-color:#F5F9F9; min-height: 100px; height: auto; border-radius: 10px; margin-top: 15px;" >
              <div class="container" style="padding: 20px; font-size: 14px; font-weight: 600; min-height: 100px; height: auto;">
                <div v-show="isShow" class="row g">

                  <div class="col-6" v-for="(l,index) in list" :key="index">
                    <div class="p-3"><li>{{ l }}</li></div>
                  </div>
                </div>
                <el-input
                    v-show="!isShow"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="words">
                </el-input>
              </div>
            </div>
          </div>

          <div class="col-4" style="font-size:16px;">
            <div class="col text-center" style=""> 
              <div style="background-color:#162E3E; width: 70%; margin: 20px auto 0px; height: 150px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
                <img src="@/assets/kcimg/ds.png" alt="" width="40%">
                <div style="text-align: center; color: white; font-weight: 600;">试看本节课</div>
              </div> 
              <div style="background-color:white; width: 70%; margin: 0px auto; height: 40px;  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
                <span style="line-height: 40px;">1-1导学</span>
              </div> 
              <el-button type="warning" style="margin-top: 10px;">购买课程</el-button>
            </div>
          </div>
        </div>
        <!-- 这一坨是课程的简介 -->
        <div class="row" style="padding-top: 10px;">
          <div class="col">
            <img src="@/assets/kcimg/course-desc-title.png" alt="" width="120px">
            <div v-show="isShow" style="font-size: 15px; padding: 25px;">
              {{ course_about }}
            </div>
            <el-input
                v-show="!isShow"
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="course_about">
            </el-input>
          </div>
        </div>

        <CourseCatalog></CourseCatalog>
      </div>
    </div>
</template>

<script>
  //引入boostrap 样式 和 js
  import CourseCatalog from './CourseCatalog.vue'
  import $ from 'jquery'
  export default {
    name:'Programmes',
    components: {
      CourseCatalog
    },
    data() {
        return {
          imageName:'',
          image:'',

          imageUrl: '',
          imageType: '',
          fileToUpload: null,

          isShow:true,
          list:[],
          words:'300+案例场景，1万+代码实践&轻松击破重难点，C++指针等&从0到1系统掌握C++基础语法&掌握编程必备的核心数据结构&紧跟前沿，学会C++11新标准&100+练习案例，强化编程思维',
          course_name:'快改课程名字',
          photo:'',
          participants:'',
          price:999,
          course_about:'AL"助学计划"， 成就每一个追梦人！精心设计更利于初学者学习和应用并重的课程体系，带你从 0到1系统化掌握C++语法，助你掌握竞赛中所有常用常见的干货，让你学习更顺畅，更高效，大大节省你从入门到精通的宝贵时间。'
        }
    },
    watch: {
      words: {
        deep:true,
        immediate:true,
        handler(value) {
          this.list = this.words.split('&')
        }
      }
    },
    created() {
      if (this.$route.query.id !== undefined) {
        const query = this.$route.query
        // console.log("query == > ", this.$route.query)
        this.course_about = query.course_about
        this.course_name = query.course_name
        this.words = query.words
        this.price = query.price
        this.photo = query.photo
      }
    },
    methods: {
        handleFileUpload(event) { // 看图片类型
          const file = event.target.files[0];
          
          const reader = new FileReader();

          reader.onload = (e) => {
            this.imageUrl = e.target.result; // 设置预览图像的URL
            // console.log("url == >", this.imageUrl)
            this.fileToUpload = file; // 将文件保存在组件数据中
            this.photo = file.name
            // 获取文件的扩展名
            const extension = file.name.split('.').pop().toLowerCase();
            // 获取文件的MIME类型
            const fileType = file.type;
            // console.log(file)
            console.log("extension", extension)
            this.image = "https://app6132.acapp.acwing.com.cn/static/image/" +  this.imageName + "." + extension
            // console.log("type", fileType)
            // 设置图片类型信息
            this.imageType = fileType;
          };

          if (file === null || file === undefined) {
            this.photo = ""
            this.imageUrl = ""
            this.imageType = ""
            
            console.log("没有图片捏")
            return
          }
          // 读取文件为DataURL
          reader.readAsDataURL(file);
        },
        uploadFile() { // 传给后端 使得图片有url
          if (!this.fileToUpload || this.imageName === "" || this.imageName === null) {
            console.error('没有选择文件 或者 没有输入图片名称');
            return;
          }

          // 创建一个FormData对象，将文件附加到其中
          const formData = new FormData();
          formData.append('image', this.fileToUpload);
          formData.append('userid', this.imageName)
          // 使用$.ajax发送文件到后端（假设上传的URL是/upload）
          $.ajax({
            url: 'https://app6132.acapp.acwing.com.cn/jdg/upload/classes/',
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: (response) => {
              console.log('文件上传成功');
              // 这里可以根据后端的响应进行相应处理
            },
            error: (error) => {
              console.error('发生错误:', error);
            }
          });
        },
        close() {
          this.isShow = false
        },
        open() {
          this.isShow = true
        },
        ClickMeToSubmit() {
          const vue = this;
          const store = this.$store;
          const route = this.$route

          if (this.$route.query.id === undefined) { // 说明是添加课程
            $.ajax({
              url:'https://app6132.acapp.acwing.com.cn/api/course/create/',
              type:'post',
              headers: {
                Authorization: "Bearer " + store.state.me.token,
              },
              data: {
                course_name: vue.course_name,
                course_about: vue.course_about,
                photo: vue.image,
                price: vue.price,
                words: vue.words,
              },
              success(resp) {
                if (resp.error_message === "success") {
                  console.log("添加课程成功了")
                } else {
                  console.log("添加课程失败了, resp == >", resp.error_message)
                }
              },
              error(resp) {
                console.log("添加课程彻底失败了, resp == >", resp)
              }
            })
          } else {
            $.ajax({
              url:'https://app6132.acapp.acwing.com.cn/api/course/update/',
              type:'post',
              headers: {
                Authorization: "Bearer " + store.state.me.token,
              },
              data: {
                id: route.query.id,
                course_name: vue.course_name,
                course_about: vue.course_about,
                photo: vue.image,
                price: vue.price,
                words: vue.words,
              },
              success(resp) {
                if (resp.error_message === "success") {
                  console.log("修改课程成功了")
                } else {
                  console.log("修改课程失败了, resp == >", resp.error_message)
                }
              },
              error(resp) {
                console.log("修改课程彻底失败了, resp == >", resp)
              }
            })
          }
        },
        ClickMeToDel() {
          const route = this.$route
          const store = this.$store
          const message = this.$message
          this.$confirm('此操作将永久删除该课程, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
            
            $.ajax({
              url:"https://app6132.acapp.acwing.com.cn/api/course/delete/",
              type:'post',
              headers: {
                Authorization: "Bearer " + store.state.me.token,
              },
              data: {
                id: route.query.id
              },
              success(resp) {
                if (resp.error_message === "success") {
                  console.log("删除课程成功辣, resp == > ", resp.error_message)
                  message({
                      type: 'success',
                      message: '删除成功! 3秒后自动关闭页面'
                  });
                  setTimeout(() => {
                      window.close()
                  }, 3000);
                } else {
                  message({
                      type: 'warning',
                      message: '删除失败了.... resp == >' + resp.error_message
                  });
                }
              },
              error(resp) {
                message({
                    type: 'warning',
                    message: '删除失败了....' + resp
                });
              }
            })
          }).catch(() => {
            message({
                type: 'info',
                message: '已取消删除'
            });          
          });
        },
    }
  }
</script>

<style scoped>
/* .custom-collapse /deep/ .el-collapse-item__wrap {
  background-color: red;
} */
/* 路由样式 */
.windows {
  width: 100%; 
  min-height: 800px;
  height: auto;
}
.luyou {
  text-decoration: none; color:black
}
.luyou:hover {
  text-decoration: none;
}
.luyou1:visited {
  color:#409EFF;
}
/* 路由样式 */
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }

  .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  
  body > .el-container {
    margin-bottom: 40px;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
</style>